import './home.css'
import { Posts } from '../../components/posts/Posts'

export const Home = () => {
  return (
    <Posts />
  )
}
